import { TextPassage } from '@petsmart-ui/sparky';
import Tile from './Tile/Tile';
import { DeliveryType } from '@libs/core';

type UnavailableDeliveryMethodTileProps = {
    deliveryMethod: string;
    isLoading?: boolean;
};

export default function UnavailableDeliveryMethodTile({
    deliveryMethod,
    isLoading,
}: Readonly<UnavailableDeliveryMethodTileProps>) {
    return (
        <Tile
            isTileDisabled={true}
            iconName="car-outline"
            title={
                <span
                    data-testid="test-delivery-method-name"
                    className="radio-field-title sparky-u-theme-typography-body-lg-bold"
                >
                    {deliveryMethod}
                </span>
            }
            value={DeliveryType.BOPIS}
            onChange={() => {
                return '';
            }}
        >
            <TextPassage
                data-testid="unavailable-component"
                className="delivery-method-status sparky-u-color-utility-error"
            >
                {isLoading ? <>&nbsp;</> : <>Not available for this item</>}
            </TextPassage>
        </Tile>
    );
}
